export default __webpack_public_path__ + "static/media/Poppins-ExtraLight.94b768c0.ttf";